export default __webpack_public_path__ + "static/media/petRequest.deaef019.png";